const messages = {
    dashboard: {
        title: "Grossistdashbord",
        extraTitle: "GROSSISTDASHBORD",
        description:
            "Velkommen til dashbordet ditt. Her kan du se tall og deltakende virksomheter blant kundene dine.",
        overview: {
            title: "Oversikt over deltakende kunder",
            description:
                "Virksomheter som har registrert seg på BRIDGESTONE PLUS og som vi kan tilordne selskapene dine via kundenummeret deres.",
            month: "Nye denne måneden",
            year: "Nye dette året",
            all: "Totalt",
        },
        credits: {
            title: "Punktkreditter {name}",
            description:
                "Premiepoeng tildelt deltakende virksomheter på grunnlag av salgstallene du har lastet opp. I denne visningen vises vanlige poeng uten kampanjer.",
            month: "Siste måned",
            year: "Løpende år",
            prev_year: "Totalt",
            allDealers: "Alle forhandlerpoeng",
        },
        details: {
            title: "Deltakende kunder i detalj",
            description:
                'Nedenfor finner du virksomhetene som har registrert seg på BRIDGESTONE <span class="text-danger">PLUS</span> med et {name}-kundenummer og er tildelt deg som ansvarlig. Bruk sorteringsfunksjonene for å endre rekkefølgen eller bruk søkefeltet.',
        },
        lastImport:
            'Siste import av salgstall: <br/> <span class="text-danger">{date}</span>',
        loadMore: "Last 20 forhandlere til",
        tyres: {
            title: "Dekk",
            description: "Dekk kjøpt av programdeltakere",
        },
    },
};

export default {
    messages,
};
